import { render, staticRenderFns } from "./benefits-tier-settings-form.vue?vue&type=template&id=b899d808&scoped=true"
import script from "./benefits-tier-settings-form.vue?vue&type=script&lang=js"
export * from "./benefits-tier-settings-form.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-settings-form.vue?vue&type=style&index=0&id=b899d808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899d808",
  null
  
)

export default component.exports